// 顺序!
export var E_Product;
(function (E_Product) {
    E_Product["Analytics"] = "Analytics";
    E_Product["Workspace"] = "Workspace";
    E_Product["Insights"] = "Insights";
    E_Product["Discovery"] = "Discovery";
    E_Product["Chemical"] = "Chemical";
    E_Product["Lifescience"] = "Lifescience";
    E_Product["Synapse"] = "Synapse";
    E_Product["IpManagement"] = "IpManagement";
    E_Product["PublicPages"] = "PublicPages";
    E_Product["Academy"] = "Academy";
})(E_Product || (E_Product = {}));
export var E_Language;
(function (E_Language) {
    E_Language["en"] = "en";
    E_Language["cn"] = "cn";
    E_Language["tw"] = "tw";
    E_Language["jp"] = "jp";
})(E_Language || (E_Language = {}));
